import { useState, useEffect } from "react";
import globalClasses from "../commoncomponents/css/Global.module.css";
import classes from "../../component/viewplans/ViewPlans.module.css";
import handshake from "../../assets/images//handshake.jpg";
import starter from "../../assets/images//starter.jpg";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import { setSnackbar } from "../../component/commoncomponents/alert/SnackbarAction";
import { setPaymentStatus } from "../registration/RegistraionAction";
import { getRequest, singoutHandler } from "../../api/AxiosAPICall";
import {
  Button,
  CircularProgress,
  Grid,
  Link,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  HorizontalRule as HorizontalRuleIcon,
  Check as CheckIcon,
} from "@mui/icons-material";
import { useNavigate, useNavigationType } from "react-router-dom";
import { useDispatch } from "react-redux";

const ViewPlansHome = (props: any) => {
  const [isMakePayment, setIsMakePayment] = useState(false);
  const [iframeSourceData, setIframeSourceData] = useState<any>();
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState("");
  const [url, setUrl] = useState("");
  const [hasFreeSubscription, setHasFreeSubscription] = useState(false);
  let navType = useNavigationType();

  let jwtToken: any;
  let paymentInterval: any;

  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();
  let history = useNavigate();

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  const fetchCellmaPreference = async () => {
    await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "cellmaflex_premium_cost",
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setPrice(response.data);
      }
    });
  };

  const fetchCellmaUrl = async () => {
    await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "cellmaflex_premium_url",
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setUrl(response.data);
      }
    });
  };
  const paymentStatus = async () => {
    await getRequest("paymentStatus", {
      params: {
        orderIdentifier: orderId,
      },
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        clearInterval(paymentInterval);
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        if (response.data === "paid") {
          clearInterval(paymentInterval);
          dispatch(setPaymentStatus("paid"));
          props?.ShowPaymentHistory();
        } else if (response.data === "failed") {
          clearInterval(paymentInterval);
          dispatch(setPaymentStatus("failed"));
          props?.ShowPaymentHistory();
        } else if (response.data === "authenticated") {
          setIframeSourceData(`${url}paymentinprogress`);
        }
      }
    });
  };

  const freePaymentSubscription = async () => {
    await getRequest("hasFreeSubscription", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setHasFreeSubscription(response.data);
      }
    });
  };
  //get Payment API response
  let orderId: any;
  const startPayment = async () => {
    setOpen(true);
    await getRequest("payment", {
      params: {
        billingAmount: price,
      },
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setIframeSourceData("data:text/html," + response.data.RedirectData);
        orderId = response.data.OrderIdentifier;
        setTimeout(async () => {
          paymentStatus();
          paymentInterval = setInterval(() => {
            paymentStatus();
          }, 1000);
        }, 10000);

        setTimeout(() => {
          setOpen(false);
        }, 5000);
      }
    });
  };

  const freePayment = async () => {
    const response = await getRequest("freemiumPayment", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });

    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "CellmaFlex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      dispatch(setPaymentStatus("free"));
      props?.ShowPaymentHistory();
    }
  };

  useEffect(() => {
    fetchCellmaPreference();
    freePaymentSubscription();
    fetchCellmaUrl();
    return () => {
      clearInterval(paymentInterval);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <CommonLayout
      footer={true}
      hidePermium={false}
      showHeaderNavigation={true}
      isLogedIn={true}
    >
      {!isMakePayment && (
        <Box>
          <Box>
            <Typography
              component="div"
              variant="h2"
              gutterBottom
              style={{ paddingTop: "5px" }}
              className={globalClasses.headingH2}
              sx={{ fontSize: { md: "34px", xs: "26px" } }}
            >
              Pick your Premium
            </Typography>
          </Box>
          <br />
          <TableContainer>
            <Table
              sx={{
                minWidth: 400,
                width: "70%",
                margin: "0 auto",
                border: "1px solid #ccc",
              }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    style={{
                      borderRight: "1px solid #ccc",
                      padding: "0px 80px 0px 0px",
                      backgroundColor: "#f3f4f6",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sm={12}
                      style={{ backgroundColor: "#c2cbd1" }}
                    >
                      <Typography
                        align="left"
                        sx={{
                          fontWeight: "bold",
                          padding: "20px 10px 20px",
                          fontSize: "26px",
                        }}
                      >
                        Our Plan
                      </Typography>
                    </Grid>
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sm={12}
                      className={classes.pricingCardHeading}
                    >
                      <img src={starter} alt="freemium" />
                      <br></br>
                      <Typography
                        className={classes.pricingCardheader}
                        sx={{ fontWeight: "bold" }}
                      >
                        FREEMIUM
                      </Typography>
                      <Typography
                        align="center"
                        variant="h6"
                        style={{
                          fontWeight: "600",
                          marginTop: "19px",
                          fontSize: "26px",
                          color: "#228743",
                        }}
                      >
                        Freemium
                      </Typography>
                    </Grid>
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sm={12}
                      className={classes.pricingCardHeading}
                    >
                      <img src={handshake} alt="permium" />
                      <br></br>
                      <Typography
                        className={classes.pricingCardheader}
                        sx={{ fontWeight: "bold" }}
                      >
                        PREMIUM
                      </Typography>
                      <Typography
                        align="center"
                        variant="h6"
                        style={{
                          fontWeight: "600",
                          marginTop: "19px",
                          fontSize: "26px",
                          color: "#1976d2",
                        }}
                      >
                        Premium
                      </Typography>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      E- Appointments-Online Bookings
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Patient Administration and Scheduling
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Electronic Patient Record
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Patient Billing
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Patient E-Communication
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Telemedicine (Online Consultations)
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      E-Prescriptions and Pharmacy
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Payment Portal
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Referral Platform
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <HorizontalRuleIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Document Management
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <HorizontalRuleIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Customised Assessments and Letters
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <HorizontalRuleIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      borderLeft: "0px soild #fff",
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "10px",
                        border: "2px solid #1a87c9",
                        padding: "13px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333333",
                      }}
                    >
                      Online Patient Assessment
                    </Box>
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    <Box className={classes.iconStyle}>
                      <HorizontalRuleIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box className={classes.iconStyle}>
                      <CheckIcon
                        style={{ color: "#1a87c9", fontSize: "40px" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    component="td"
                    scope="row"
                    style={{ borderRight: "1px solid #ccc" }}
                  ></TableCell>
                  <TableCell
                    align="center"
                    style={{ borderRight: "1px solid #ccc" }}
                  >
                    {" "}
                    <Box className={classes.getstartedBtnBoxStyle}>
                      <Button
                        className={classes.getstartedBtn}
                        variant="contained"
                        sx={{
                          marginBottom: "22px",
                          backgroundColor: hasFreeSubscription
                            ? "gray !important"
                            : "",
                        }}
                        onClick={() => freePayment()}
                        disabled={hasFreeSubscription}
                      >
                        Get Started
                      </Button>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    {" "}
                    <Box className={classes.getstartedBtnBoxStyle}>
                      <Button
                        disabled={true}
                        className={classes.getstartedBtn}
                        variant="contained"
                        sx={{
                          marginBottom: "22px",
                          backgroundColor: "gray !important",
                        }}
                        onClick={() => {
                          startPayment();
                          setIsMakePayment(true);
                        }}
                      >
                        Get Started
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {isMakePayment && (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Link
            onClick={() => {
              props?.ShowPaymentHistory();
            }}
            sx={{ alignSelf: "flex-start !important", marginLeft: "30px" }}
          >
            Payment History
          </Link>
          {open ? (
            <Box className={globalClasses.loader}>
              <CircularProgress color="primary" disableShrink />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <iframe
                  style={{
                    minHeight: "550px",
                    display: "flex",
                    minWidth: "1000px",
                    backgroundColor: "white",
                    position: "sticky",
                    border: "2px solid #f0f0f0",
                  }}
                  title="threedsIframe"
                  id="threedsIframe"
                  scrolling="no"
                  src={iframeSourceData}
                />
              </Box>
            </>
          )}
        </Grid>
      )}
    </CommonLayout>
  );
};

export default ViewPlansHome;
